export default "__VITE_ASSET__BbNd9WVl__"